// extracted by mini-css-extract-plugin
export default {"center":"ImageViewer_center__PB9zj"};